import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Megaphone, Plus, Star } from 'lucide-react';
import { ConsumerLayout } from '@/components/consumer/ConsumerLayout';
import { useMinhasSolicitacoes } from '@/hooks/useSolicitacoes';
import { estadoSolicitacao } from '@/lib/solicitacoes';

export default function ConsumerPedidos() {
  const { t } = useTranslation();
  const { data: pedidos, isLoading } = useMinhasSolicitacoes();

  return (
    <ConsumerLayout>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-lg font-bold text-foreground">{t('requests.title')}</h1>
        <Link to="/app/pedidos/novo" className="ow-btn ow-btn--primary inline-flex items-center gap-1">
          <Plus className="h-4 w-4" /> {t('requests.new')}
        </Link>
      </div>

      {isLoading ? (
        <div className="space-y-2">
          {[0, 1, 2].map((i) => <div key={i} className="h-16 rounded-lg bg-muted animate-pulse" />)}
        </div>
      ) : !pedidos || pedidos.length === 0 ? (
        <div className="flex flex-col items-center text-center text-muted-foreground py-16 gap-3">
          <Megaphone className="h-10 w-10" />
          <p>{t('requests.empty')}</p>
          <Link to="/app/pedidos/novo" className="ow-btn ow-btn--primary">{t('requests.new')}</Link>
        </div>
      ) : (
        <ul className="space-y-2">
          {pedidos.map((p) => {
            const est = estadoSolicitacao(p.status);
            return (
              <li key={p.id}>
                <Link to={`/app/pedidos/${p.id}`} className="block rounded-lg border border-border p-3 hover:bg-muted">
                  <div className="flex items-center justify-between">
                    <span className="font-medium text-foreground">{p.categoria.nome}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${est.classe}`}>{t(est.labelKey)}</span>
                  </div>
                  <div className="text-sm text-muted-foreground">{p.cidade}</div>
                  <div className="mt-1 inline-flex items-center gap-1 text-xs text-muted-foreground">
                    <Star className="h-3 w-3" />
                    {t('requests.quotesCount', { count: p.n_orcamentos })}
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </ConsumerLayout>
  );
}
